// Cutover (M2, migration 033): orders placed before HHL Ops aren't on any PO here and Shopify doesn't show
// them as incoming, so until they're re-entered the plan may suggest ordering that stock again. Both plans say so until
// someone marks them entered (planning_settings.prior_orders_entered; planning settings can bring the note back).
import { isOpen } from "../../../shared/po.ts";
import { can } from "../lib/mutate.ts";
import { saveSettings } from "../lib/planning.ts";
import { Link } from "../lib/router.tsx";
import { useRows } from "../lib/sync.ts";
import { Button } from "../ui/controls.tsx";
import { Notice } from "../ui/PageParts.tsx";

export function CutoverBanner() {
  const settings = useRows("planning_settings")[0];
  const pos = useRows("po");
  if (!settings || settings.prior_orders_entered) return null;
  const live = pos.filter((p) => p.kind !== "service" && isOpen(p.status));
  const drafts = live.filter((p) => p.status === "draft").length;
  const sent = live.length - drafts;
  const done = () =>
    confirm("Are the open orders placed before HHL Ops all on POs here now? This hides the note on both plans (planning settings bring it back).") &&
    saveSettings({ prior_orders_entered: true });
  return (
    <Notice
      more={
        <>
          Put each one still open on a PO:{" "}
          <Link to="/pos" className="font-medium underline">
            Purchase orders
          </Link>{" "}
          → New PO → Paste lines from the vendor's PI or your sheet (a build at a CM: a run's make order, its builds under What). Then Mark as sent, not Send to
          vendor: they have it already (a warning that the plan says otherwise is expected: go ahead). Sent, one shipping to HHL shows as incoming in Shopify.
        </>
      }
      actions={
        can("planning_settings.update") && (
          <Button size="sm" onClick={done}>
            They're all entered
          </Button>
        )
      }
    >
      Orders placed before HHL Ops aren't on POs here yet, so the plan may suggest that stock again. On POs so far: {sent} open
      {drafts ? `, ${drafts} draft${drafts === 1 ? "" : "s"}` : ""}.
    </Notice>
  );
}
